/**
 * Sliders
 */
 import { tns } from '../../../../node_modules/tiny-slider/src/tiny-slider';
 import { Breakpoints } from './settings';

( function Sliders() {

    const stats_slider_selector= '[data-js="scroll-stats"] [data-js="list"]';
    const gallery_slider_selector = '[data-js-gallery-slider] [data-js-items]';

    // Init stats slider
    if( document.querySelector( stats_slider_selector ) ) {

        initStatsSlider();

    }
    // Init gallery slider
    if( document.querySelector( gallery_slider_selector ) ) {

        initGallerySlider();

    }



    /**
     * Stats Slider
     */
    function initStatsSlider() {

        const stats_slider = tns( {
            container:              stats_slider_selector,
            axis:                   'vertical',
            items:                  2,
            slideBy:                'page',
            controlsContainer:      '[data-js="scroll-buttons"]',
            nav:                    false,
            autoplay:               true,
            autoplayTimeout:        10000,
            autoplayHoverPause:     true,
            autoplayButtonOutput:   false,
            speed:                  750
        } );

        document.querySelector( '[data-js="scroll-stats"]' ).classList.remove( 'is-hidden' );

    }


    /**
     * Gallery Slider
     */
    function initGallerySlider() {

        const gallery_slider = tns( {
            container:              gallery_slider_selector,
            //axis:                 'vertical',
            autoHeight:             false,
            mode:                   'gallery',
            items:                  1,
            controlsContainer:      '[data-js-scroll-buttons]',
            autoplay:               true,
            autoplayTimeout:        10000,
            autoplayHoverPause:     true,
            autoplayButtonOutput:   false,
            lazyload:               true,
            speed:                  750
        } );

        $(window).load( () => {

            const slider_props = gallery_slider.getInfo();
            const button_container = slider_props.controlsContainer;
            const index_holder = button_container.querySelector( '[data-js-index]' );

            // Resize to fix bug with initial height
            fixInitHeight( slider_props );

            // Set fixed height.
            //setFixedHeight( slider_props );


            // Track changes
            gallery_slider.events.on( 'indexChanged', () => {

                index_holder.innerHTML = gallery_slider.getInfo().navCurrentIndex + 1;

            } );

        } );

        /**
          * Set fixed height.
          *
          * @param Object slider_props
          */
         function setFixedHeight( slider_props ) {

           // Get all images within slider.
           Array.from( slider_props.slideItems ).map( slide => {

             const height = slide.offsetHeight;
             console.log( height );

           } );
         }

        /**
         * Fix init height
         *
         * There seems to be a bug with init load
         * @dev need to report on github repo
         *
         * @param Object slider_props
         */
        function fixInitHeight( slider_props ) {

            const $fix_me = $(slider_props.container.parentNode);
            const first_slide_height = slider_props.container.querySelector( '.tns-item' ).offsetHeight;


            $fix_me.css( 'height', first_slide_height );


        }


    }



} )();





// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/sliders.js